module.exports = __webpack_public_path__ + "img/zain_gray.e894b285.png";